// Google Analytics helper functions

declare global {
  interface Window {
    gtag?: (
      command: string,
      targetId: string,
      config?: Record<string, any>
    ) => void;
  }
}

// Track custom events
export const trackEvent = (
  eventName: string,
  eventParams?: Record<string, any>
) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, eventParams);
  }
};

// Specific event tracking functions
export const trackLogin = (method: 'email' | 'google') => {
  trackEvent('login', {
    method,
  });
};

export const trackConnectDatabase = () => {
  trackEvent('connect_db', {
    timestamp: new Date().toISOString(),
  });
};

export const trackChat = (messageLength: number) => {
  trackEvent('chat', {
    message_length: messageLength,
  });
};

export const trackSaveMetric = (metricType: string) => {
  trackEvent('save_metric', {
    metric_type: metricType,
  });
};
